import { Button, Tag, Space, Typography } from 'antd';
import { EditOutlined, MailOutlined, CalendarOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { templateTypeLabels } from '../../data/emailTemplates';

const { Text } = Typography;

const templateIcons = {
  booking_confirmed: <MailOutlined style={{ fontSize: 18, color: '#008385' }} />,
  booking_rescheduled: <CalendarOutlined style={{ fontSize: 18, color: '#faad14' }} />,
  booking_cancelled: <CloseCircleOutlined style={{ fontSize: 18, color: '#ff4d4f' }} />,
};

const templateColors = {
  booking_confirmed: 'cyan',
  booking_rescheduled: 'orange',
  booking_cancelled: 'red',
};

export const getTemplateColumns = (onEdit) => [
  {
    title: 'Template',
    key: 'name',
    render: (_, record) => (
      <Space size="middle">
        {templateIcons[record.type]}
        <div>
          <Text strong>{record.name}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }} ellipsis={{ tooltip: record.subject }}>
            {record.subject?.length > 50 ? `${record.subject.substring(0, 50)}...` : record.subject}
          </Text>
        </div>
      </Space>
    ),
  },
  {
    title: 'Type',
    key: 'type',
    render: (_, record) => (
      <Tag color={templateColors[record.type]}>
        {templateTypeLabels[record.type]}
      </Tag>
    ),
  },
  {
    title: 'Last Modified',
    key: 'lastModified',
    render: (_, record) => {
      return(
      <Text type="secondary">
        {record.lastModified}
      </Text>
    )},
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (_, record) => (
      <Button
      style={{color:"#008385"}}
        type="link"
        icon={<EditOutlined />}
        onClick={() => onEdit(record.type)}
      >
        Edit
      </Button>
    ),
  },
];
